export default function AdminTableContainer({ className = "", children }) {
  return (
    <div className={`admin-console__table-wrap admin-data-health-table-wrap${className ? ` ${className}` : ""}`}>
      {children}
    </div>
  );
}
